// SVG icon sprites for the Ordini page — no external icon library.

type IconProps = { className?: string; style?: React.CSSProperties };

const IC = "stroke-current fill-none stroke-[1.6] [stroke-linecap:round] [stroke-linejoin:round]";

export function IconSearch({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="8" />
      <path d="M21 21l-4.35-4.35" />
    </svg>
  );
}

export function IconCalendar({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  );
}

export function IconCheck({ className, style }: IconProps) {
  return (
    <svg
      className={
        className ??
        "fill-none stroke-white stroke-[3] [stroke-linecap:round] [stroke-linejoin:round]"
      }
      style={style}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}

export function IconCaretDown({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

export function IconCopy({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  );
}

export function IconSync({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M21 12a9 9 0 1 1-9-9c2.5 0 4.78.94 6.5 2.5" />
      <path d="M21 3v6h-6" />
    </svg>
  );
}

export function IconDownload({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
    </svg>
  );
}

export function IconFileCatalog({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <path d="M9 13l2 2 4-4" />
    </svg>
  );
}

export function IconMail({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <path d="M22 6l-10 7L2 6" />
    </svg>
  );
}

export function IconCheckSquare({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9 11l3 3L22 4" />
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
    </svg>
  );
}

export function IconTracking({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M16 3h5v5M21 3l-7 7M8 21H3v-5M3 21l7-7" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  );
}

export function IconSend({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M22 2L11 13" />
      <path d="M22 2l-7 20-4-9-9-4 20-7z" />
    </svg>
  );
}

/** «Riordina» come sostituzione (Davide 24/09): un carrello, perche' e' un
 *  acquisto al fornitore. Non l'aereo di carta di «Invia LDV» e «Ordina»: in
 *  colonna Azioni stavano uno sopra l'altro e si confondevano. */
export function IconCart({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="8" cy="21" r="1" />
      <circle cx="19" cy="21" r="1" />
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
    </svg>
  );
}

export function IconPrint({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v8H6z" />
    </svg>
  );
}

/** Ridisegno card lista (Piano 3 Task 3): "Crea reso" nella colonna Azioni. */
export function IconReturn({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 10h10a5 5 0 0 1 0 10h-2" />
      <path d="M7 6L3 10l4 4" />
    </svg>
  );
}

/** Ridisegno card lista (Piano 3 Task 3): "Crea sostituzione" nella colonna
 *  Azioni — doppia freccia = scambio/sostituzione. */
export function IconSwap({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 3v14" />
      <path d="M3 7l4-4 4 4" />
      <path d="M17 21V7" />
      <path d="M21 17l-4 4-4-4" />
    </svg>
  );
}

/** Ridisegno card lista (Piano 3 Task 3): "Apri pagina ordine" nella colonna
 *  Azioni (ridondante col clic-riga, ma esplicita). */
export function IconArrowRight({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 12h14" />
      <path d="M13 6l6 6-6 6" />
    </svg>
  );
}

/** Redesign card F2 (2026-07-14): tasto "Chiamata" (registro CRM chiamate). */
export function IconPhone({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

/** Storico spedizione (orologio che torna indietro): la riga della
 *  sostituzione nella colonna Spedizione apre lo storico del SUO codice. */
export function IconHistory({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
      <path d="M3 3v5h5M12 7v5l3 2" />
    </svg>
  );
}

/** Avviso: triangolo col punto esclamativo (popup Riordina, 2026-10-05). */
export function IconAlert({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
      <path d="M12 9v4M12 17h.01" />
    </svg>
  );
}

/** «Rimetti in magazzino» (Davide 2026-11-03): scaffale con la freccia che entra. */
export function IconRientro({ className, style }: IconProps) {
  return (
    <svg className={className ?? IC} style={style} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 21V9l9-5 9 5v12" />
      <path d="M7 21v-6h10v6" />
      <path d="M12 7v5" />
      <path d="M9.5 9.5L12 12l2.5-2.5" />
    </svg>
  );
}
